import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { GoalCategoriesFormValues } from "src/models/GoalCategories.model";
import GoalCategoriesForm from "../Layout/GoalCategoriesForm";
import { useAddGoalCategoryMutation } from "src/services/GoalCategoryServices";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddGoalCategoriesFormWrapper = ({ onClose }: Props) => {
  const [addGoal] = useAddGoalCategoryMutation();
  const [saveNextChecked, setSaveNextChecked] = useState<boolean>(true);
  // Form Initial Values
  const initialValues: GoalCategoriesFormValues = {
    categoryName: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    categoryName: string().required("Please enter category name"),
  });

  // Handle Submit
  const handleSubmit = (
    values: GoalCategoriesFormValues,
    { setSubmitting, resetForm }: FormikHelpers<GoalCategoriesFormValues>
  ) => {
    const formattedValues = {
      categoryName: values?.categoryName,
    };
    addGoal(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <GoalCategoriesForm
              formikProps={formikProps}
              onClose={onClose}
              formType={"Add"}
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddGoalCategoriesFormWrapper;
